import { useEffect, useRef, useState } from "react";

/**
 * Site réel affiché dans le mockup de portable.
 *
 * Le PNG a une découpe TRANSPARENTE à la place de l'écran : l'iframe se place
 * dessous et l'image passe par-dessus (sans capter la souris), ce qui évite
 * d'avoir à redessiner un cadre.
 *
 * Zone d'écran mesurée sur le PNG (652 × 500) : x 65→582, y 27→347.
 */
const ECRAN = { gauche: 9.97, haut: 5.4, largeur: 79.45, hauteur: 64.2 };
const RATIO_IMAGE = 652 / 500;

// Le site est rendu comme sur un vrai écran de bureau, puis réduit. Sans ça, le
// site responsive basculerait en version tablette dans un cadre de portable.
const LARGEUR_LOGIQUE = 1280;
const HAUTEUR_LOGIQUE = Math.round(LARGEUR_LOGIQUE / (518 / 321));

export default function EcranPortable({ src, titre, className = "" }) {
  const zone = useRef(null);
  const [echelle, setEchelle] = useState(0);

  useEffect(() => {
    const cible = zone.current;
    if (!cible) return;
    const mesurer = () => setEchelle(cible.clientWidth / LARGEUR_LOGIQUE);
    mesurer();
    // La largeur dépend du conteneur, pas seulement de la fenêtre : un
    // ResizeObserver suit aussi les changements de mise en page.
    const observateur = new ResizeObserver(mesurer);
    observateur.observe(cible);
    return () => observateur.disconnect();
  }, []);

  return (
    <div className={`relative mx-auto ${className}`} style={{ aspectRatio: RATIO_IMAGE }}>
      <div
        ref={zone}
        className="absolute overflow-hidden bg-white"
        style={{
          left: `${ECRAN.gauche}%`,
          top: `${ECRAN.haut}%`,
          width: `${ECRAN.largeur}%`,
          height: `${ECRAN.hauteur}%`,
        }}
      >
        {echelle > 0 && (
          <iframe
            src={src}
            title={titre}
            loading="lazy"
            className="border-0 block"
            style={{
              width: LARGEUR_LOGIQUE,
              height: HAUTEUR_LOGIQUE,
              transform: `scale(${echelle})`,
              transformOrigin: "top left",
            }}
          />
        )}
      </div>
      {/* L'image par-dessus : sans pointer-events-none, elle avalerait le
          défilement et les clics destinés au site. */}
      <img
        src={`${process.env.PUBLIC_URL}/mockup-ordi.png`}
        alt=""
        aria-hidden="true"
        className="relative w-full pointer-events-none select-none"
      />
    </div>
  );
}
